import React from 'react';
import Field from './Field'
import TypingTester from '@lib/TypingTester'

export default class FieldCheckboxSelect extends Field {
    constructor(props) {
        super(props)
        this.tester = new TypingTester(250)
        this.state = {
            selectedOptions: Array.isArray(props.value) ? props.value : []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let value = []
        if (nextProps.value) {
            value = nextProps.value
        }

        this.setState({
            selectedOptions: value
        })
    }

    onOptionChange = item => {
        let selectedOptions = this.state.selectedOptions
        let index = selectedOptions.findIndex(x => x.id === item.value.id);
        if (index > -1) {
            selectedOptions.splice(index, 1)
        } else {
            selectedOptions.push({id: item.value.id, quantity: 1})
        }

        this.setState({
            selectedOptions: selectedOptions
        })

        if (this.props.onChange) {
            this.props.onChange(selectedOptions)
        }
    }

    isOptionChecked = value => {
        return this.state.selectedOptions.findIndex(x => x.id === value.id) > -1
    }

    getValueFromState = item => {
        var fromState = this.state.selectedOptions.find(x => x.id === item.value.id);
        return fromState ? fromState.quantity : item.value.quantity;
    }

    onQuantityChange = (e, item) => {
        let index = this.state.selectedOptions.findIndex(x => x.id === item.value.id);
        if (index === -1) {
            return;
        }

        let selectedOptions = [...this.state.selectedOptions];
        selectedOptions[index].quantity = Number(e.target.value);

        this.setState({
            selectedOptions: selectedOptions
        })

        this.tester.record(() => {
            this.props.onChange(selectedOptions)
        })
    }

    renderField() {
        var className = ['configuration-radiogroup'];
        if (this.props.partitionSize)
            className.push('partition')

        return (
            <div className={className.join(' ')}>
                {this.renderFieldInternal()}
            </div>
        )
    }

    renderFieldInternal() {
        var items = this.props.items;
        if (this.props.partitionSize) {
            return this.renderByPart();
        }

        return (
            items.map(item => this.renderItem(item))
        )
    }

    renderByPart() {
        var items = this.props.items;
        var parts = items.grouping(2);
        return (
            parts.map(part => (
                <table className="configuration-radiogroup-part">
                    <tbody>
                    {part.map(item => this.renderItem(item))}
                    </tbody>
                </table>
            ))
        )
    }

    renderItem(item) {
        let itemId = this.generateUniqueId()

        return (
            <tr key={item.value.id} className="configuration-radiogroup-item"
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <td>
                    <input id={itemId} type="checkbox" disabled={this.props.disabled}
                           checked={this.isOptionChecked(item.value)} onChange={e => this.onOptionChange(item)}/>
                    <label tabIndex="0" htmlFor={itemId}>{__(item.text)}</label>
                </td>
                <td style={{minWidth: '35px', maxWidth: '35px', marginLeft: '10px', marginRight: '10px'}}>
                    {this.isOptionChecked(item.value) &&
                        <input
                            min={1}
                            disabled={this.props.disabled}
                            type="number" value={this.getValueFromState(item)}
                            onChange={e => this.onQuantityChange(e, item)}
                            onKeyUp={e => e.which === 9 ? this.onTabFocus(e) : {}}/>}
                </td>
            </tr>
        )
    }
}